import React from 'react'
import { Editor, EditorState, RichUtils } from 'draft-js'
import { Container, Header, Menu, Tip, BlockLabel } from './styles'
import { customBlockStyleFn, customInlineStyles } from './DSConfigs'
import Button from './components/Button'
import Heading from './components/Dropdowns/Heading'

export interface RichTextAreaProps {
    title: string
    value: EditorState
    onChange: (html: EditorState) => void
}
const RichTextArea = ({ title, value, onChange }: RichTextAreaProps): JSX.Element => {
    const handleMenuItems = (action: string, changeOn: 'blockType' | 'inlineStyle'): void => {
        switch (changeOn) {
            case 'inlineStyle':
                onChange(RichUtils.toggleInlineStyle(value, action))
                break
            case 'blockType':
                onChange(RichUtils.toggleBlockType(value, action))
                break
        }
    }

    return (
        <Container>
            <Header>
                <Tip>
                    <BlockLabel>{title}</BlockLabel>
                </Tip>
                <Menu>
                    <Button dropdown={true} classIcon={'fas fa-heading'}>
                        <Heading onClick={element => handleMenuItems(element, 'inlineStyle')} />
                    </Button>
                    <Button
                        dropdown={false}
                        classIcon={'fas fa-bold'}
                        onClick={() => handleMenuItems('BOLD', 'inlineStyle')}
                    />
                    <Button
                        dropdown={false}
                        classIcon={'fas fa-italic'}
                        onClick={() => handleMenuItems('ITALIC', 'inlineStyle')}
                    />
                    <Button
                        dropdown={false}
                        classIcon={'fas fa-underline'}
                        onClick={() => handleMenuItems('UNDERLINE', 'inlineStyle')}
                    />
                    <Button
                        dropdown={false}
                        classIcon={'fas fa-align-left'}
                        onClick={() => handleMenuItems('LEFT', 'blockType')}
                    />
                    <Button
                        dropdown={false}
                        classIcon={'fas fa-align-center'}
                        onClick={() => handleMenuItems('CENTER', 'blockType')}
                    />
                    <Button
                        dropdown={false}
                        classIcon={'fas fa-align-right'}
                        onClick={() => handleMenuItems('RIGHT', 'blockType')}
                    />
                    <Button
                        dropdown={false}
                        classIcon={'fas fa-align-justify'}
                        onClick={() => handleMenuItems('JUSTIFY', 'blockType')}
                    />
                    <Button
                        dropdown={false}
                        classIcon={'fas fa-list-ul'}
                        onClick={() => handleMenuItems('unordered-list-item', 'blockType')}
                    />
                    <Button
                        dropdown={false}
                        classIcon={'fas fa-list-ol'}
                        onClick={() => handleMenuItems('ordered-list-item', 'blockType')}
                    />
                    <Button
                        dropdown={false}
                        classIcon={'fas fa-highlighter'}
                        onClick={() => handleMenuItems('MONOSPACE', 'inlineStyle')}
                    />
                    <Button
                        dropdown={false}
                        classIcon={'fas fa-quote-right'}
                        onClick={() => handleMenuItems('blockquote', 'blockType')}
                    />
                </Menu>
            </Header>
            <Editor
                editorState={value}
                onChange={currentState => {
                    onChange(currentState)
                }}
                blockStyleFn={customBlockStyleFn}
                customStyleMap={customInlineStyles}
            />
        </Container>
    )
}

export default RichTextArea
